import { em, percent } from "csx";
import * as React from "react";
import { useCallback, useEffect, useRef, useState } from "react";
import { stylesheet } from "typestyle";
import { IconNames, MaterialIcon } from "../icon.js";
import { classNames } from "../utils.js";
import { CharCodes, emulateInput } from "./emulateInput.js";
export function useTypeRef() {
    const [type, setType] = useState(() => () => console.log("No-op type function called. That is probably a mistake."));
    const wrappedSetter = useCallback((value) => setType(() => value), [setType]);
    return [type, wrappedSetter];
}
export function TextInput(props) {
    const { value, onChange, onFocus, onBlur, disabled, error, outline, type, backspace = true, className, inputRef, placeholder, typeRef, endAdornment, } = props;
    const input = useRef(null);
    const handleChange = useCallback((e) => {
        onChange && onChange(e.currentTarget.value);
    }, [onChange]);
    const handleType = useCallback((key) => {
        if (input.current) {
            emulateInput(input.current, key);
            onChange && onChange(input.current.value);
        }
    }, [input.current]);
    const handleBackspace = useCallback(() => handleType(String.fromCharCode(CharCodes.Backspace)), [handleType]);
    useEffect(() => typeRef && typeRef(handleType), [typeRef, handleType]);
    useEffect(() => {
        if (inputRef) {
            inputRef.current = input.current;
        }
    }, [inputRef, input.current]);
    return (React.createElement("div", { className: classNames(styles.textInput, (outline && error) && styles.textInputError, outline && styles.textInputOutline, className) },
        React.createElement("input", { type: type, ref: input, onChange: handleChange, onFocus: onFocus, onBlur: onBlur, value: value, className: styles.input, disabled: disabled, placeholder: placeholder }),
        React.createElement("div", { className: styles.endAdornment },
            endAdornment && (endAdornment),
            backspace && (React.createElement("button", { onClick: handleBackspace, disabled: disabled, className: styles.backspace },
                React.createElement(MaterialIcon, { icon: IconNames.backspace, className: styles.backspaceIcon }))))));
}
const styles = stylesheet({
    textInput: {
        position: "relative",
        fontSize: em(2),
        height: em(2),
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center'
    },
    textInputOutline: {
        border: "1px solid var(--color-foreground)",
        backgroundColor: "var(--color-input-background)",
        borderRadius: "2em",
    },
    textInputError: {
        border: "1px solid var(--color-error)",
        backgroundColor: "var(--color-error-background)",
    },
    input: {
        width: percent(100),
        height: percent(100),
        border: 0,
        backgroundColor: "transparent",
        color: "inherit",
        textAlign: "center",
        padding: "0 1.5em"
    },
    endAdornment: {
        position: 'absolute',
        right: 0,
        zIndex: 10
    },
    backspace: {
        border: 0,
        backgroundColor: "transparent",
        color: "inherit",
        padding: em(0.5),
        cursor: "pointer"
    },
    backspaceIcon: {
        fontSize: em(1),
    }
});
//# sourceMappingURL=TextInput.js.map